export const SET_PROPOSALS = 'SET_PROPOSALS';
